import axios from "axios";

export default async function getAllConsumer({
  length,
  start,
  column,
  order,
  search,
  searchType,
  startDate,
  endDate
}) {
  const params = {
    length,
    start,
    column,
    order,
    search,
    searchType
  };

  if (startDate) {
    params.start_date = startDate;
  }
  if (endDate) {
    params.end_date = endDate;
  }
  const response = await axios.get(
    '/consumer/admin/api/v1/user-listing',
    {
      params
    }
  );

  return response;
}